import { faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function popupActions(props) {
    const getClearAll = () => {
        if (props.hasItems) {
            return (
                <div className="mark-read" onClick={props.clearAll}>
                    <span>Clear all</span>
                    <div><FontAwesomeIcon icon={faTimesCircle} /></div>
                </div>
            );
        }
        return (
            <div className="mark-read" />
        );
    };
    return (
        <div className="action-bar">
            <div className="badge view" onClick={props.viewAll}>View all</div>
            {getClearAll()}
        </div>
    );
}

export const PopupActions = popupActions;
